import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

// Affiliate shortlink: rippleprogress.com/r/CODE → stores the code and lands
// on signup. Keeps affiliate links tidy for social/text sharing.
export default function ReferralRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (code) localStorage.setItem("fp_ref_code", code.toUpperCase());
    navigate("/auth/signup", { replace: true });
  }, [code, navigate]);
  return null;
}
